import React from 'react';
import './Section.css';

const Section = ({
  children,
  variant = 'default',
  className = '',
  id,
  ...props
}) => {
  const baseClass = 'linear-section';
  const variantClass = `linear-section--${variant}`;
  const classes = `${baseClass} ${variantClass} ${className}`.trim();

  return (
    <section
      id={id}
      className={classes}
      {...props}
    >
      <div className="linear-section-container">
        {children}
      </div>
    </section>
  );
};

export default Section;


